module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mostrarModalTrabajadores) ? _c('modal-trabajadores-area', {
    attrs: {
      "trabajadores": _vm.trabajadoresArea,
      "seleccionados": _vm.trabajadoresSeleccionados,
      "nombre-area": _vm.nombreArea,
      "is-loading": _vm.isLoadingTrabajadores
    },
    on: {
      "aceptar": _vm.aceptarTrabajadores,
      "close": function($event) {
        _vm.mostrarModalTrabajadores = false
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "cambio-dias"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "little"
  }, [_vm._v("Cambio de días en vacaciones")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-datos",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, [(_vm.empleado && _vm.empleado.codigo) ? _c('div', {
    key: "indicaciones-cambio-dias",
    staticClass: "indicaciones"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Datos a tener en cuenta")])]), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Ingresando cambio de días para ")]), _c('strong', [_vm._v(_vm._s(_vm.empleado.nombre))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Su jefe es ")]), _c('strong', [_vm._v(_vm._s(_vm.empleado.nombreJefe))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Días por tomar ")]), _c('strong', [_vm._v(" " + _vm._s(_vm.empleado.diasReales))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Días por programar ")]), _c('strong', [_vm._v(" " + _vm._s(_vm.empleado.diasDisponibles))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Le llegará un mail de notificación a ")]), _c('strong', [_vm._v(_vm._s(_vm.empleado.nombre) + " ")]), _c('span', [_vm._v("con los días cambiados")])]), _c('hr'), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Va a ")]), (_vm.signo === '-') ? _c('strong', [_vm._v("quitar ")]) : _c('strong', [_vm._v("agregar ")]), _c('strong', [_vm._v(_vm._s(_vm.dias) + " ")]), _c('span', [_vm._v(_vm._s(_vm.dias === 1 ? 'día ' : 'días ') + " a ")]), _c('strong', [_vm._v(_vm._s(_vm.empleado.nombre))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Sus días quedarían de esta manera")])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Días por tomar ")]), (_vm.signo === '-') ? _c('strong', [_vm._v(_vm._s(+_vm.empleado.diasReales - +_vm.dias))]) : _c('strong', [_vm._v(_vm._s(+_vm.empleado.diasReales + +_vm.dias))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Días por programar ")]), (_vm.signo === '-') ? _c('strong', [_vm._v(_vm._s(+_vm.empleado.diasDisponibles - +_vm.dias))]) : _c('strong', [_vm._v(_vm._s(+_vm.empleado.diasDisponibles + +_vm.dias))])])])]) : _vm._e(), _c('div', {
    key: "transaccion",
    staticClass: "contenedor-transaccion"
  }, [_c('div', {
    staticClass: "flex-data"
  }, [_c('div', {
    staticClass: "flex jcc"
  }, [_c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.opcionCambiarDias),
      expression: "opcionCambiarDias"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "opciones",
      "value": "individual"
    },
    domProps: {
      "checked": _vm._q(_vm.opcionCambiarDias, "individual")
    },
    on: {
      "change": [function($event) {
        _vm.opcionCambiarDias = "individual"
      }, _vm.handlerModalidad]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Individual")])]), (_vm.empresa !== 'raymisa') ? _c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.opcionCambiarDias),
      expression: "opcionCambiarDias"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "opciones",
      "value": "area"
    },
    domProps: {
      "checked": _vm._q(_vm.opcionCambiarDias, "area")
    },
    on: {
      "change": [function($event) {
        _vm.opcionCambiarDias = "area"
      }, _vm.handlerModalidad]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Área")])]) : _vm._e(), _c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.opcionCambiarDias),
      expression: "opcionCambiarDias"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "opciones",
      "value": "todo"
    },
    domProps: {
      "checked": _vm._q(_vm.opcionCambiarDias, "todo")
    },
    on: {
      "change": [function($event) {
        _vm.opcionCambiarDias = "todo"
      }, _vm.handlerModalidad]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Toda la empresa")])])])]), (_vm.empresa !== 'raymisa' && _vm.opcionCambiarDias === 'area') ? _c('div', {
    staticClass: "flex jcc"
  }, [_c('div', {
    staticClass: "control flex-1 title-singular"
  }, [_c('p', [_vm._v("Area")]), _c('div', {
    staticClass: "input-container"
  }, [(!_vm.idArea) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idArea),
      expression: "idArea"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading,
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.idArea)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idArea = $event.target.value
      }
    }
  }) : _c('div', {
    staticClass: "item fdc flex-1"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.nombreArea)))]), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.nombreGerencia))])]), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.borrarArea
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaArea) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-area', {
    on: {
      "selected": _vm.seleccionarArea,
      "close": function($event) {
        _vm.mostrarBusquedaArea = false
      }
    }
  })], 1) : _vm._e()])], 1)]) : _vm._e(), (_vm.opcionCambiarDias === 'area' && _vm.idArea) ? _c('div', {
    staticClass: "resumen-seleccion"
  }, [(_vm.cantidadTrabajadoresSeleccionados > 0) ? [_c('div', {
    staticClass: "resumen-contenido"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })]), _c('div', {
    staticClass: "resumen-texto"
  }, [_c('strong', [_vm._v(_vm._s(_vm.cantidadTrabajadoresSeleccionados) + "\n" + _vm._s(_vm.cantidadTrabajadoresSeleccionados === 1 ? ' trabajador seleccionado' : ' trabajadores seleccionados'))]), _c('span', [_vm._v("del área " + _vm._s(_vm.nombreArea))])]), _c('button', {
    staticClass: "button button-small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalTrabajadores
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v("Modificar selección")])])])] : [_c('div', {
    staticClass: "sin-seleccion"
  }, [_c('span', [_vm._v("No hay trabajadores seleccionados.")]), _c('button', {
    staticClass: "button button-small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalTrabajadores
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _c('span', [_vm._v("Seleccionar trabajadores")])])])]], 2) : _vm._e(), (_vm.opcionCambiarDias === 'individual') ? _c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Codigo de empleado")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoEmpleado),
      expression: "codigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.codigoEmpleado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.codigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), (_vm.signo === '+') ? _c('div', {
    staticClass: "dias"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Días")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dias),
      expression: "dias"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dias = $event.target.value
      }
    }
  })])]) : _vm._e(), (_vm.signo === '-') ? _c('div', {
    staticClass: "contenedor-datos"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', [_vm._v("Desde")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaInicioQuitaDia),
      expression: "fechaInicioQuitaDia"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaInicioQuitaDia)
    },
    on: {
      "change": _vm.calculoDias,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaInicioQuitaDia = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-left-20"
  }, [_c('label', [_vm._v("Hasta")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaFinQuitaDia),
      expression: "fechaFinQuitaDia"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaFinQuitaDia)
    },
    on: {
      "change": _vm.calculoDias,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaFinQuitaDia = $event.target.value
      }
    }
  })])]) : _vm._e()]), _c('div', {
    staticClass: "signo"
  }, [_c('p', [_vm._v("¿Que acción va a realizar?")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'is-selected': _vm.signo === '-'
    },
    on: {
      "click": function($event) {
        return _vm.cambiarSigno('-')
      }
    }
  }, [_c('span', [_vm._v("Quitar días")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'is-selected': _vm.signo === '+'
    },
    on: {
      "click": function($event) {
        return _vm.cambiarSigno('+')
      }
    }
  }, [_c('span', [_vm._v("Agregar días")])])])]), _c('div', {
    staticClass: "motivo"
  }, [_c('div', [_c('p', [_vm._v("Motivo")]), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Puedes seleccionar uno de los siguientes ejemplos y editarlos")]), _c('div', {
    staticClass: "motivos-ejemplo"
  }, _vm._l((_vm.motivosEjemplo), function(o) {
    return _c('span', {
      on: {
        "click": function($event) {
          _vm.motivo = o
        }
      }
    }, [_vm._v(_vm._s(o))])
  }), 0), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivo),
      expression: "motivo"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.motivo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motivo = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "acciones"
  }, [_c('button', {
    staticClass: "button",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.cambiar()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save"
  })]), _c('span', [_vm._v("Cambiar días")])])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6800236","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Cambio_Dias_Vacaciones.vue
// module id = 935
// module chunks = 0